/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chat_medium'
export default icon
